import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  const handleBottomPadding = () => {
    requestAnimationFrame(() => {
      $(document.body).css('padding-bottom', `${window.innerWidth >= 768 ? 0 : node.offsetHeight}px`)
    })
  }

  handleBottomPadding()
  window.addEventListener('resize', handleBottomPadding)

  return () => {
    window.removeEventListener('resize', handleBottomPadding)
  }
})
